module.exports = __webpack_public_path__ + "static/img/f4.6131309.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/f4.png
// module id = 2kNe
// module chunks = 1